/** Tela da casca que avisa que uma área do UYZY atual ainda não chegou ao novo UYZY. */
export const UNDER_CONSTRUCTION_PATH = '/em-construcao';

/** Rota antiga da explicação (D11); hoje só redireciona para `UNDER_CONSTRUCTION_PATH`. */
export const LEGACY_UNAVAILABLE_PATH = '/legado-indisponivel';

/**
 * Caminho interno da tela "Em construção" para um caminho do UYZY atual (U15, X15): o app nunca
 * manda para o legado nem abre outra aba.
 */
export function underConstructionPath(legacyPath: string): string {
  return `${UNDER_CONSTRUCTION_PATH}?caminho=${encodeURIComponent(legacyPath)}`;
}
